var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid py-2 py-md-3 py-lg-4" }, [
    _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("h2", { staticClass: "mb-1" }, [
        _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "accordion",
        attrs: { itemscope: "", itemtype: "https://schema.org/FAQPage" },
      },
      _vm._l(_vm.faqs, function (faq, index) {
        return _c("div", { key: "question-" + index }, [
          _c(
            "div",
            {
              staticClass: "card multi",
              attrs: {
                itemscope: "",
                itemprop: "mainEntity",
                itemtype: "https://schema.org/Question",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { id: "heading-" + index },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "collapsed",
                      attrs: {
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#collapse-" + index,
                        "aria-controls": "#" + "collapse-" + index,
                        "aria-expanded": "false",
                        "data-oevent-category": faq.tms.category,
                        "data-oevent-action": faq.tms.action,
                        "data-oevent-label": faq.tms.label,
                      },
                    },
                    [
                      _c("span", { staticClass: "accordion-card-title" }, [
                        _c("span", {
                          staticClass: "accordion-title",
                          attrs: { itemprop: "name" },
                          domProps: { innerHTML: _vm._s(faq.question) },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "accordion-icon",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collapse",
                  attrs: {
                    id: "collapse-" + index,
                    "aria-labelledby": "answer-qst-" + index,
                    itemscope: "",
                    itemprop: "acceptedAnswer",
                    itemtype: "https://schema.org/Answer",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "accordion-card-body standard",
                      attrs: { itemprop: "text" },
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(faq.answer) },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }